import {useState, useLayoutEffect, useRef, useEffect} from 'react';

interface UseTimeoutHandler {
  start: () => any;
  stop: () => any;
}

export function useTimeout(callback: () => void, delay: number = 0): UseTimeoutHandler {
  const [active, setActive] = useState(false);
  const callbackRef = useRef<() => any>();

  const stop = (): void => setActive(false);
  const start = (): void => setActive(true);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useLayoutEffect((): void | (() => void) => {
    if (!active) return;

    const fire = (): void => {
      if (callbackRef.current) callbackRef.current();
      stop();
    };

    const timeout = window.setTimeout(fire, delay);
    // eslint-disable-next-line consistent-return
    return () => window.clearTimeout(timeout);
  }, [active, delay]);

  return {
    start,
    stop,
  };
}
